import React from 'react';
import { Layout } from 'antd';
import s from './style.less';

const { Footer } = Layout;

const FooterBarB = (props) => {
  return (
    <Footer className={s.footerB} style={props.style}>
      <a
        rel="noopener noreferrer"
        target="_blank"
        href="https://www.99bill.com/seashell/html/corp/aboutuscn.html"
      >关于快钱</a>|
      <a
        rel="noopener noreferrer"
        target="_blank"
        href="https://news.99bill.com/modules/news/index.php?storytopic=3"
      >新闻中心</a>|
      <a
        rel="noopener noreferrer"
        target="_blank"
        href="https://www.99bill.com/seashell/html/corp/partnership.html"
      >合作伙伴</a>|
      <a
        rel="noopener noreferrer"
        target="_blank"
        href="https://www.99bill.com/seashell/html/corp/jobs.html"
      >诚聘英才</a>|
      <a
        rel="noopener noreferrer"
        target="_blank"
        href="https://www.99bill.com/seashell/html/corp/maps.html"
      >网站地图</a>
      <p>快钱版权所有 2004-2018</p>
    </Footer>
  );
};

export default FooterBarB;



// WEBPACK FOOTER //
// ./src/views/MainLayout/FooterBar/FooterBarB.jsx